import React from 'react';
import { init } from 'mirage-api-client';
import config from '../config';

export default function useAPIClientInit() {
  React.useEffect(() => {
    init({ baseUrl: config.baseUrl });
  }, []);
}
